import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Spinner, Badge } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft, faCheckCircle, faInfoCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const ModalReactivarSuscripcion = ({
    show,
    onClose,
    onConfirm,
    processing,
    suscripcionInfo
}) => {
    if (!show) return null;

    return (
        <Modal
            show={show}
            onHide={processing ? undefined : onClose}
            size="md"
            backdrop="static"
            aria-labelledby="modal-reactivar-suscripcion-title"
            centered
        >
            <Modal.Header className="border-bottom-0 pb-0">
                <Modal.Title id="modal-reactivar-suscripcion-title" className="d-flex align-items-center gap-2 text-success">
                    <FontAwesomeIcon icon={faRotateLeft} />
                    <span>Reactivar Suscripción</span>
                </Modal.Title>
                {!processing && (
                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={onClose} />
                )}
            </Modal.Header>

            <Modal.Body className="pt-2">
                {/* Info de la suscripción */}
                <div className="bg-light rounded p-3 mb-3 d-flex align-items-start gap-2 border">
                    <FontAwesomeIcon icon={faInfoCircle} className="text-primary mt-1 flex-shrink-0" />
                    <div className="w-100">
                        <p className="mb-1 text-dark fw-semibold fs--1">
                            ¿Deseas reactivar esta suscripción?
                        </p>
                        {suscripcionInfo && (
                            <div>
                                <p className="mb-1 text-muted fs--1 fw-bold">
                                    {suscripcionInfo.vNombreSuscripcion || 'Suscripción'}{' '}
                                    <Badge bg="secondary" className="ms-1">#{suscripcionInfo.idSuscripcion}</Badge>
                                </p>
                                {suscripcionInfo.dFechaCancelacion && (
                                    <small className="text-warning-emphasis d-block">
                                        Cancelación programada para: <strong>{new Date(suscripcionInfo.dFechaCancelacion).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}</strong>
                                    </small>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* Explicación del impacto */}
                <div className="border border-success-subtle bg-success-subtle rounded p-3 mb-3">
                    <div className="d-flex align-items-start gap-2">
                        <FontAwesomeIcon icon={faCheckCircle} className="text-success mt-1 flex-shrink-0" />
                        <div className="fs--1 text-dark">
                            <strong>Efecto de la reactivación:</strong>
                            <ul className="mb-0 ps-3 mt-1 text-muted fs--2">
                                <li>Se retirará la programación de cancelación en el Admin Panel.</li>
                                {suscripcionInfo?.vStripeSubscriptionId && (
                                    <li>Se revertirá la cancelación al término del período en Stripe.</li>
                                )}
                                <li>La suscripción continuará activa y se renovará con normalidad.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Botones de acción */}
                <div className="d-flex flex-column gap-2 mt-3">
                    {processing ? (
                        <Button variant="success" disabled size="sm" className="w-100 fw-bold py-2">
                            <Spinner as="span" animation="border" size="sm" role="status" className="me-2" aria-hidden="true" />
                            Reactivando suscripción...
                        </Button>
                    ) : (
                        <Button
                            onClick={onConfirm}
                            variant="success"
                            size="sm"
                            className="w-100 fw-bold py-2 shadow-sm d-flex align-items-center justify-content-center gap-2"
                        >
                            <FontAwesomeIcon icon={faRotateLeft} />
                            <span>Confirmar y Reactivar Suscripción</span>
                        </Button>
                    )}

                    {!processing && (
                        <Button onClick={onClose} variant="outline-secondary" size="sm" className="w-100">
                            <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
                            Cancelar, mantener como está
                        </Button>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

ModalReactivarSuscripcion.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    processing: PropTypes.bool,
    suscripcionInfo: PropTypes.object
};

export default ModalReactivarSuscripcion;
